<template>
  <div>
    <h5 class="headline">{{ $t('contract.signature.headline') }}</h5>
    <table style="width:100%">
      <tr style="vertical-align: top;">
        <td style="width:50%; ">
          <span>{{ $t('contract.signature.distributor_text') }}</span>
        </td>
        <td style="width:50%">
          <span>{{ $t('contract.signature.supplier_text') }}</span>
        </td>
      </tr>
      <tr style="height: 200px; vertical-align: top;">
        <td style="width:50%; ">
          <span>{{ date }}</span>
        </td>
        <td style="width:50%">
          <span>{{ date }}</span>
        </td>
      </tr>
      <tr>
        <td>{{ $t('contract.signature.signature_line') }}</td>
        <td>{{ $t('contract.signature.signature_line') }}</td>
      </tr>
      <tr>
        <td>{{ distributorName }}</td>
        <td>{{ supplierName }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  methods: {
    formatDate(date) {
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }
  },
  computed: {
    distributorName() {
      return this.$store.state.contract.parties.distributor.name !== ""
        ? this.$store.state.contract.parties.distributor.name
        : this.$t("contract.signature.placeholder.name");
    },
    supplierName() {
      return this.$store.state.contract.parties.supplier.name !== ""
        ? this.$store.state.contract.parties.supplier.name
        : this.$t("contract.signature.placeholder.name");
    },
    date() {
      return this.$store.state.contract.signature.date !== ""
        ? this.formatDate(this.$store.state.contract.signature.date)
        : this.$t("contract.signature.placeholder.date");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/SignatureOutput.vue